import { inject, Injectable } from "@angular/core";
import { EnvironmentService } from "../environment.service";

@Injectable({
    providedIn: 'root'
})
export class MicrosoftClarityService {
    environmentService = inject(EnvironmentService);
    projectId: string = this.environmentService.getClarityTrackingId();
    init() {
        if (this.projectId && this.projectId.length > 0) {
           const microsoftClarityScript = document.createElement('script');
           microsoftClarityScript.innerHTML = `(function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "${this.projectId}");`;
        
           document.head.appendChild(microsoftClarityScript);  
        }
    }

    // createCustomEvent(eventName: string) {
    //     if (this.projectId?.length > 0 && typeof window['clarity'] === 'function') {
    //         (window as any)['clarity']("event",eventName);
    //     }
    // }

    // setCustomTag(key:string, value:string) {
    //     if (this.projectId?.length > 0 && typeof window['clarity'] === 'function') {
    //         (window as any)['clarity']("set",key,value);
    //     }
    // }

}